const home = {
  path: 'home',
  component: resolve => require(['../../../../pages/teacher/course/home'], resolve)
}

export default home



// WEBPACK FOOTER //
// ./src/router/teacher/course/home/index.js